import { animated, useSpring } from "react-spring";
import { useEffect, useState, useRef } from "react";

type FADE_IN = {
  children: any;
};

export const FadeIn = ({ children }: FADE_IN) => {
  const listInnerRef = useRef<HTMLInputElement>(null);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    getStart();
  }, []);

  const getStart = async () => {
    await timeout(400);
    setIsVisible(true);
  };

  function timeout(delay: number) {
    return new Promise((res) => setTimeout(res, delay));
  }
  const styles = useSpring({
    opacity: isVisible ? 1 : 0,
    y: isVisible ? 0 : 24,
  });

  const handleScroll = (e: any) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      setIsVisible(true);
      console.log("bottom");
    }
  };

  return (
    <animated.div style={styles}>
      <div onScroll={handleScroll}>{children}</div>
    </animated.div>
  );
};
